
import { LOGIN_EVENT } from "../../reducerTypes";
import { setStorage } from "../../../../@core/utility";

const initialState = {
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_EVENT:
      const tokenData = action.payload.token;
      if(action.payload.user){
        setStorage('user', JSON.stringify(action.payload.user))
      }
      if(tokenData){
        if(tokenData.tokenType){
          setStorage('type', tokenData.tokenType);
        }
        if(tokenData.accessToken){
          setStorage('accessToken',tokenData.accessToken);
        }
        if(tokenData.refreshToken){
          setStorage('refreshToken',tokenData.refreshToken);
        }
        if(tokenData.expiresIn){
          setStorage('expire',tokenData.expiresIn);
        }
      }
      return state
    default:
      return state
  }
}

export default authReducer
